import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "flex flex-column gap-4" }
const _hoisted_3 = { class: "flex flex-column gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "component"
}, "Tarrif Component", -1)
const _hoisted_5 = { class: "flex flex-column gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "description"
}, "Tarrif Description", -1)
const _hoisted_7 = { class: "flex flex-column gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "value"
}, "Value", -1)
const _hoisted_9 = { class: "flex flex-column gap-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "unit"
}, "Unit", -1)
const _hoisted_11 = { class: "flex align-items-center justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PInputNumber = _resolveComponent("PInputNumber")!
  const _component_PDropdown = _resolveComponent("PDropdown")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _component_PConfirmDialog = _resolveComponent("PConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PCard, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_WTitle, { text: "Financial Inputs" }),
          _withDirectives(_createVNode(_component_PButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddNewOrEdit = true)),
            icon: "pi pi-plus",
            rounded: "",
            size: "small"
          }, null, 512), [
            [
              _directive_tooltip,
              `Add a new financial input`,
              void 0,
              { left: true }
            ]
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_PDataTable, {
          alwaysShowPaginator: false,
          highlightOnSelect: true,
          loading: _ctx.loading,
          resizableColumns: true,
          rowHover: true,
          rows: 100,
          showGridlines: true,
          sortOrder: 1,
          stripedRows: true,
          value: _ctx.list,
          "data-key": "id",
          paginator: "",
          size: "small"
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No records found.")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PColumn, {
              bodyClass: "text-left",
              class: "justify-content-center",
              field: "component",
              header: "Tarrif Component",
              headerClass: "py-3",
              sortable: "",
              style: {"width":"150px"}
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left text-wrap",
              class: "justify-content-center",
              field: "description",
              header: "Tarrif Description",
              headerClass: "py-3"
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left",
              field: "value",
              header: "Value",
              headerClass: "py-3"
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left",
              class: "justify-content-center",
              field: "unit",
              header: "Unit",
              headerClass: "py-3",
              style: {"width":"120px"}
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-right",
              headerClass: "py-3",
              style: {"size":"100px"}
            }, {
              body: _withCtx(({ data }) => [
                _withDirectives(_createVNode(_component_PButton, {
                  onClick: ($event: any) => (_ctx.doEdit(data)),
                  class: "p-button-xs",
                  icon: "pi pi-pencil",
                  rounded: "",
                  severity: "success",
                  text: ""
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    `Edit`,
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createVNode(_component_PButton, {
                  onClick: ($event: any) => (_ctx.doDelete($event, data.id)),
                  icon: "pi pi-trash",
                  rounded: "",
                  severity: "danger",
                  size: "small",
                  text: ""
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    `Delete`,
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value"])
      ]),
      _: 1
    }),
    _createVNode(_component_PDialog, {
      header: `${_ctx.editing? 'Edit' : 'Add a new'}`,
      onHide: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelAddOrEdit())),
      modal: "",
      style: {"min-width":"600px"},
      visible: _ctx.showAddNewOrEdit,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showAddNewOrEdit) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_PInputText, {
              autocomplete: "off",
              id: "component",
              size: "small",
              modelValue: _ctx.item.component,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.component) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_PInputText, {
              autocomplete: "off",
              id: "description",
              size: "small",
              modelValue: _ctx.item.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_PInputNumber, {
              useGrouping: false,
              autocomplete: "off",
              id: "value",
              maxFractionDigits: "50",
              minFractionDigits: "1",
              mode: "decimal",
              size: "small",
              modelValue: _ctx.item.nvalue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.nvalue) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_PDropdown, {
              options: _ctx.unitsList,
              class: "w-full",
              id: "unit",
              optionLabel: "unit",
              optionValue: "id",
              placeholder: "Select a unit",
              modelValue: _ctx.item.unitId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.unitId) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_PButton, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelAddOrEdit())),
              label: "Cancel",
              outlined: "",
              severity: "secondary",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editing? _ctx.saveUpdates() : _ctx.doAdd())),
              label: "Save",
              size: "small"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_PConfirmDialog)
  ], 64))
}